__turbopack_context__.v({
  "active": "sport-module-sass-module__gAuT2q__active",
  "base": "sport-module-sass-module__gAuT2q__base",
  "gamesCount": "sport-module-sass-module__gAuT2q__gamesCount",
  "hasFavorite": "sport-module-sass-module__gAuT2q__hasFavorite",
  "hasFavourite": "sport-module-sass-module__gAuT2q__hasFavourite",
  "selected": "sport-module-sass-module__gAuT2q__selected",
  "sidebar": "sport-module-sass-module__gAuT2q__sidebar",
  "sportItem": "sport-module-sass-module__gAuT2q__sportItem",
  "sportName": "sport-module-sass-module__gAuT2q__sportName",
});
